module.exports = __webpack_public_path__ + "img/dynamic-8.79b0be46.png";